module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"joinNewsletter":"Join our newsletter","subscribe":"Subscribe","yourEmail":"Your email..."},"de":{"joinNewsletter":"Newsletter abonnieren","subscribe":"Anmelden","yourEmail":"Ihre E-Mail-Adresse..."}}')
  delete Component.options._Ctor
}
